import * as eventsModel from './models/events';
import { selectors, classes } from './elements/constants';
import addTargetEventListener from '../events/addTargetEventListener';
import { updatePanelClasses } from './models/panel';

function handleShowStep(event) {
  const { target, detail: { fromPanel } = {} } = event;
  const panel = target.querySelector(selectors.panelInterstitial);
  const delay = parseInt(panel.dataset.delay || '3');

  target.dataset.backTargetId = fromPanel && fromPanel.dataset.id;

  setTimeout(() => {
    if (target.classList.contains(classes.active)) {
      eventsModel.dispatchNavigateEvent(target, { direction: 'forwards' });
    }
  }, delay * 1000);
}

function handleHideStep(event) {
  window.setTimeout(() => {
    // setting complete to false will ensure it animates from the right each time
    // since we never show this panel on "backwards" navigation
    updatePanelClasses(event.target, { complete: false });
  }, 500);
}

addTargetEventListener(eventsModel.events.showStep, selectors.flexPanelInterstitial, handleShowStep);
addTargetEventListener(eventsModel.events.hideStep, selectors.flexPanelInterstitial, handleHideStep);
